import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Some tricks I learned recording & publishing an educational video every day for 30 days",
  "description": "",
  "published": "2018-05-24T00:00:00.000Z",
  "redirect_from": ["/blog/learned-recording-educational-video-every-day/swizec/8405"],
  "categories": "Personal, Side Projects, Thoughts",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2018/05/F5F63D9C-009C-4F68-A4F5-EFF20A28E0E9.png",
        "alt": null
      }}></img></p>
    <p>{`From April 5th to May 9th, I published `}<a parentName="p" {...{
        "href": "https://www.youtube.com/playlist?list=PLF8WgaD4xmjWuh7FTYTealxehOuNor_2S"
      }}>{`30 videos about React`}</a>{` on the internets. All of the internets. `}<a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/981932124231024640"
      }}>{`Twitter`}</a>{`, `}<a parentName="p" {...{
        "href": "https://www.facebook.com/swizecpage/"
      }}>{`Facebook`}</a>{`, `}<a parentName="p" {...{
        "href": "https://www.youtube.com/playlist?list=PLF8WgaD4xmjWuh7FTYTealxehOuNor_2S"
      }}>{`YouTube`}</a>{`, `}<a parentName="p" {...{
        "href": "https://learnwhileyoupoop.com/"
      }}>{`learnwhileyoupoop.com`}</a>{`. Each video up to 2 minutes 20 seconds long, each part of my initial `}<a parentName="p" {...{
        "href": "https://learnwhileyoupoop.com"
      }}>{`Learn While You Poop`}</a>{` series, each starting in my bathroom, some with drawings on mirrors, others with computer screencasts.`}</p>
    <p>{`Goal was to publish 30 instructional videos in 30 days and test the hypothesis that a quick lightweight approach to teaching new technical skills exists. It went great 😎`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Not sure, if it’s just me but past few weeks this has been the first link I’ve shared, when somebody asks for programming related learning material. `}<br parentName="p"></br><br parentName="p"></br>{`It might be just me…`}<br parentName="p"></br><br parentName="p"></br>{`💩`}<br parentName="p"></br><br parentName="p"></br>{`🤣 ➡️ 🚪`}</p>{`— Tuomas Jomppanen (@tuomasj) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/tuomasj/status/998526109317828608"
      }}>{`May 21, 2018`}</a></blockquote>
    <p>{`Altho… the full playlist is just 29 videos. Did I lose count? 🤔`}</p>
    <p>{`And there's 34 days between Apr 5th and May 9th because staying on the wagon is hard but not too hard, heh 😇`}</p>
    <p>{`6560 views on YouTube`}</p>
    <p>{`12019 views on Twitter`}</p>
    <p>{`5729 views on Facebook (+ 56k paid but meh)`}</p>
    <p>{`Overall, great success! 💪`}</p>
    <p>{`As I prep to start the next 30-day module, here are some things I'll have to keep in mind 👇`}</p>
    <h3 {...{
      "id": "1-keep-your-head-still"
    }}>{`1. Keep your head still`}</h3>
    <p>{`George Clooney in an interview with David Letterman once said the director of ER told him: `}<em parentName="p">{`"Man, you could be a great actor one day if only you learn to keep your head still!"`}</em></p>
    <p>{`I don't know about that director, but I find the less I move my head, the easier it is to fix problems in my line delivery with editing tricks. Missed a word? Started rambling? Cut it out when editing.`}</p>
    <p>{`If your head doesn't move, the viewer won't even notice the cut.`}</p>
    <h3 {...{
      "id": "2-eye-contact-with-the-camera"
    }}>{`2. Eye contact with the camera`}</h3>
    <p>{`Make eye contact with the camera. You are talking to the person who is watching, and your eyes are captivating. The better you keep focus on the camera, the better they'll keep focus on the video.`}</p>
    <p>{`Avoid darting your eyes to the screen to check if your shot is good. Your shot is okay and the camera is on. Look deep into the lens.`}</p>
    <h3 {...{
      "id": "3-keep-your-volume-stable"
    }}>{`3. Keep your volume stable`}</h3>
    <p>{`When you forget a word, you tend to draaaaag out the previous word then say the next word super loud when you remember it.`}</p>
    <p>{`You gooooooo INTO THe woods.`}</p>
    <p>{`This is hard to edit and annoying to listen to. Keep your volume stable and you can cut out any awkward pauses. Cover up a lot. The viewer won't even notice.`}</p>
    <h3 {...{
      "id": "4-dont-draaaaaag-out-words-when-you-forget-a-line"
    }}>{`4. Don't draaaaaag out words when you forget a line`}</h3>
    <p>{`Even better than keeping your volume stable is to avoid dragging out words when you forget a line. You don't have to keep making noise.`}</p>
    <p>{`Forgot your line? Shut up.`}</p>
    <p>{`Silence is easy to cut out. Especially if you keep your head still.`}</p>
    <h3 {...{
      "id": "5-forgot-a-line-try-again"
    }}>{`5. Forgot a line, try again`}</h3>
    <p>{`If you forget a line, just try again. Do not stop the camera. Do not reset the shot. Just shut up for a second or two, then try again.`}</p>
    <p>{`You can cut out the false starts. You will save a lot of time, if you just keep going and repeat the same stuff multiple times.`}</p>
    <p>{`Especially if you keep your head still.`}</p>
    <h3 {...{
      "id": "6-change-your-shot"
    }}>{`6. Change your shot`}</h3>
    <p>{`Watching still video is boring and your audience will drift away. Try to change the shot every 20 to 30 seconds.`}</p>
    <p>{`The reason you can't keep your eyes of the TV is that you're both predator and prey. Your brain is hardwired to motion interrupts.`}</p>
    <p>{`If you see motion out of the corner of your eye, you look. You then give it your attention for a bit, then return to whatever.`}</p>
    <p>{`Still shots don't hold your attention. Shots changing too often overwhelm you and don't hold your attention.`}</p>
    <p>{`Shots changing just often enough make it impossible for you to look away because whenever your attention is about to wander, your subconscious motion detector gets pinged again.`}</p>
    <p>{`This is why screencasts and college lectures are so hard to watch while a TV running in the room steals everyone's attention.`}</p>
    <h3 {...{
      "id": "7-build-a-buffer"
    }}>{`7. Build a buffer`}</h3>
    <p>{`Staying on the wagon is hard. Making video every day is hard.`}</p>
    <p>{`Sure, it takes just 1 hour to make a 2-minute video when things go well. But shit happens.`}</p>
    <p>{`Bug in your code? Oops, video took 3 hours, and you're not getting sleep tonight.`}</p>
    <p>{`Bug in your gear? Aaaargh.`}</p>
    <p>{`Girlfriend wants to have a nice dinner and spend some time with you? Shit, no video tonight, I guess.`}</p>
    <h3 {...{
      "id": "8-mornings-are-not-quiet"
    }}>{`8. Mornings are not quiet`}</h3>
    <p>{`Morning time is quiet time. You are left alone and you can write a lot. It's great.`}</p>
    <p>{`But video requires actual silence. Your microphone picks up all the noise that comes from the street and from your girlfriend in the bathroom and from your bird waking up and…`}</p>
    <p>{`Basically, you have to record at night. Or in a special room that you don't have.`}</p>
    <h3 {...{
      "id": "9-timebox"
    }}>{`9. Timebox`}</h3>
    <p>{`Your video is never going to be perfect. Your taste is better than your skill. Your time is more limited than you think.`}</p>
    <p>{`If you want to publish every day, you often have to say `}<em parentName="p">{`"Fuck it, this is good enough"`}</em>{` and press the magic button.`}</p>
    <p>{`That's okay. Not everything has to be a hit.`}</p>
    <p>{`Some videos will get more views some will get less. They all contribute to getting in front of people and building your audience. Keep pressing publish.`}</p>
    <p><a parentName="p" {...{
        "href": "https://zenpencils.com/comic/90-ira-glass-advice-for-beginners/"
      }}>{`Your skills will catch up to your taste.`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      